import { PluginKey } from 'prosemirror-state'
const commentsKey = new PluginKey('COMMENTS_PLUGIN')
export { commentsKey }
export default {
  commentsKey,
}
